export enum ContactUploadAction {
  Create = 'create',
  Update = 'createAndUpdate',
  OptOut = 'optOut'
}

export enum ContactUploadRouterAction {
  CreateAndUpdate = 'create-and-update',
  OptOut = 'opt-out'
}
